import { MapPin } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const NM_CITIES = [
  "Albuquerque",
  "Rio Rancho",
  "Santa Fe",
  "Las Cruces",
  "Roswell",
  "Farmington",
  "Hobbs",
  "Clovis",
  "Carlsbad",
  "Alamogordo",
  "Gallup",
  "Los Alamos",
  "Los Lunas",
  "Bernalillo",
  "Belen",
  "Espanola",
  "Taos",
  "Silver City",
  "Deming",
  "Artesia",
  "Portales",
  "Las Vegas",
  "Grants",
  "Socorro",
  "Tucumcari",
  "Ruidoso",
  "Truth or Consequences",
  "Corrales",
  "Placitas",
  "Edgewood",
];

export function NMServiceArea({ variant = "section" }: { variant?: "section" | "footer" }) {
  const { t } = useI18n();
  if (variant === "footer") {
    return (
      <div>
        <div className="mb-5 flex items-center gap-2 border-b border-primary-foreground/10 pb-3">
          <MapPin className="h-4 w-4 text-accent" aria-hidden />
          <h3 className="font-serif text-base text-accent">{t("nmArea.footerTitle")}</h3>
        </div>
        <ul
          className="grid grid-cols-2 gap-x-6 gap-y-2 text-xs text-primary-foreground/75 sm:grid-cols-3 lg:grid-cols-5"
          aria-label={t("nmArea.citiesAria")}
        >
          {NM_CITIES.map((c) => (
            <li key={c} className="flex items-center gap-1.5 transition-colors hover:text-accent">
              <span className="h-1 w-1 shrink-0 rounded-full bg-accent/60" aria-hidden />
              <span className="truncate">
                {c}, <span className="text-primary-foreground/50">NM</span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <section
      aria-labelledby="nm-cities-title"
      className="bg-background py-16 sm:py-20"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <MapPin className="mx-auto h-7 w-7 text-accent" aria-hidden />
          <h2
            id="nm-cities-title"
            className="mt-3 font-serif text-3xl font-bold text-primary sm:text-4xl"
          >
            {t("nmArea.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-muted-foreground sm:text-base">
            {t("nmArea.sub")}
          </p>
        </div>

        <ul
          className="mx-auto mt-10 grid max-w-4xl grid-cols-2 gap-2 text-sm sm:grid-cols-3 lg:grid-cols-5"
          aria-label={t("nmArea.citiesAria")}
        >
          {NM_CITIES.map((c) => (
            <li
              key={c}
              className="rounded-md border border-border bg-secondary/60 px-3 py-2 text-center font-medium text-primary"
            >
              {c}
            </li>
          ))}
        </ul>

        <p className="mt-8 text-center text-xs text-muted-foreground">
          {t("nmArea.dontSee")}{" "}
          <a href="tel:+15058680847" className="font-semibold text-accent-strong hover:underline">
            (505) 868-0847
          </a>{" "}
          {t("nmArea.toConfirm")}
        </p>
      </div>
    </section>
  );
}
